/**
 * DO NOT EDIT THIS FILE!
 * This file is auto generated by "grunt build-verifone-status-names" to help with development.
 *
 * This is a list of all the possible statuses extracted from all integration types
 * We can use these in code instead of strings.
 * Beware that a status might not exist for the integration type in use! Refer to the separate status lists
 * to see what is possible for that integration type.
 */
const VerifoneStatusNames = Object.freeze({
    WAITING_FOR_GRATUITY: 'WAITING_FOR_GRATUITY',
    GRATUITY_BEING_ENTERED: 'GRATUITY_BEING_ENTERED',
    AWAITING_CARD: 'AWAITING_CARD',
    SWIPE_CARD: 'SWIPE_CARD',
    CARD_INSERTED: 'CARD_INSERTED',
    CARD_REMOVED: 'CARD_REMOVED',
    CARD_PROCESSING: 'CARD_PROCESSING',
    CHANGE_CARD: 'CHANGE_CARD',
    KEY_IN_CARD_DETAILS: 'KEY_IN_CARD_DETAILS',
    WAITING_FOR_CASHBACK: 'WAITING_FOR_CASHBACK',
    PIN_ENTRY: 'PIN_ENTRY',
    RISK_MANAGEMENT_COMPLETE: 'RISK_MANAGEMENT_COMPLETE',
    AUTHORISING_TRANSACTION: 'AUTHORISING_TRANSACTION',
    WAITING_FOR_RESULT: 'WAITING_FOR_RESULT',
    AUTH_RESULT_RECEIVED: 'AUTH_RESULT_RECEIVED',
    PRINTING_MERCHANT_RECEIPT: 'PRINTING_MERCHANT_RECEIPT',
    SIGNATURE_CONFIRMATION_REQUIRED: 'SIGNATURE_CONFIRMATION_REQUIRED',
    CONTINUE_REQUIRED: 'CONTINUE_REQUIRED',
    CONFIRM_AUTH_CODE: 'CONFIRM_AUTH_CODE',
    CONFIRMING_TRANSACTION: 'CONFIRMING_TRANSACTION',
    REJECTING_TRANSACTION: 'REJECTING_TRANSACTION',
    FINAL_RESULT_RECEIVED: 'FINAL_RESULT_RECEIVED',
    VOICE_REFERRAL: 'VOICE_REFERRAL',
    REMOVE_CARD: 'REMOVE_CARD',
    DOWNLOADING_FILE: 'DOWNLOADING_FILE',
    UPDATING_PED: 'UPDATING_PED',
    CARD_DATA_RETRIEVAL: 'CARD_DATA_RETRIEVAL',
    STARTING_TRANSACTION: 'STARTING_TRANSACTION',
    PERFORMING_DOWNLOAD: 'PERFORMING_DOWNLOAD',
    REQUESTING_REPORT: 'REQUESTING_REPORT',
    EXPIRY_DATE_REQUIRED: 'EXPIRY_DATE_REQUIRED',
    START_DATE_REQUIRED: 'START_DATE_REQUIRED',
    AVS_HOUSE_NUMBER_REQUIRED: 'AVS_HOUSE_NUMBER_REQUIRED',
    AVS_POST_CODE_REQUIRED: 'AVS_POST_CODE_REQUIRED',
    CSC_REQUIRED: 'CSC_REQUIRED',
    LOGIN_REQUIRED: 'LOGIN_REQUIRED',
    READY: 'READY',
    CARD_NOT_ACCEPTED: 'CARD_NOT_ACCEPTED',
    TRANSACTION_CANCELLED: 'TRANSACTION_CANCELLED',
    PRINTING_CUSTOMER_RECEIPT: 'PRINTING_CUSTOMER_RECEIPT',
    INITIALISING_PED: 'INITIALISING_PED',
    PED_UNAVAILABLE: 'PED_UNAVAILABLE',
    CARD_APPLICATION_SELECTION: 'CARD_APPLICATION_SELECTION',
    RETRY_DOWNLOAD: 'RETRY_DOWNLOAD',
    RESTART_AFTER_SOFTWARE_UPDATE: 'RESTART_AFTER_SOFTWARE_UPDATE',
    UNSAFE_DOWNLOAD: 'UNSAFE_DOWNLOAD',
    UNEXPECTED_LOGIN: 'UNEXPECTED_LOGIN',
    REGISTER_FOR_ACCOUNT_ON_FILE_DECISION: 'REGISTER_FOR_ACCOUNT_ON_FILE_DECISION',
    AWAITING_TOKEN_ID: 'AWAITING_TOKEN_ID',
    DOWNLOAD_COMPLETE: 'DOWNLOAD_COMPLETE',
    DOWNLOAD_STILL_BEING_PREPARED: 'DOWNLOAD_STILL_BEING_PREPARED',
    SERVER_CONNECTION_FAILED: 'SERVER_CONNECTION_FAILED',
    RESUME_DOWNLOAD: 'RESUME_DOWNLOAD',
    CARD_ERROR: 'CARD_ERROR',
    UPDATE_TRANSACTION_VALUE_DECISION: 'UPDATE_TRANSACTION_VALUE_DECISION',
    INVALID_AMOUNT: 'INVALID_AMOUNT',
    MERCHANT_REFERENCE_REQUIRED: 'MERCHANT_REFERENCE_REQUIRED',
    ENTER_AMOUNT: 'ENTER_AMOUNT',
    CONFIRM_AUTHORISATION: 'CONFIRM_AUTHORISATION',
    CARD_EXPIRED: 'CARD_EXPIRED',
    INVALID_ACCOUNT: 'INVALID_ACCOUNT',
    INVALID_CAPTURE_METHOD: 'INVALID_CAPTURE_METHOD',
    INVALID_CARD_NUMBER: 'INVALID_CARD_NUMBER',
    INVALID_CONFIGURATION: 'INVALID_CONFIGURATION',
    INVALID_EXPIRY_DATE: 'INVALID_EXPIRY_DATE',
    INVALID_TRACK2_FORMAT: 'INVALID_TRACK2_FORMAT',
    INVALID_TRANSACTION_TYPE: 'INVALID_TRANSACTION_TYPE',
    KEYED_ENTRY_NOT_ALLOWED: 'KEYED_ENTRY_NOT_ALLOWED',
    CARD_SCHEME_NOT_RECOGNISED: 'CARD_SCHEME_NOT_RECOGNISED',
    TRANSACTION_TYPE_NOT_ALLOWED: 'TRANSACTION_TYPE_NOT_ALLOWED',
    INVALID_CARD_SECURITY_CODE: 'INVALID_CARD_SECURITY_CODE',
    MERCHANT_RECEIPT: 'MERCHANT_RECEIPT',
    INVALID_AUTH_CODE: 'INVALID_AUTH_CODE',
    PIN_BLOCKED: 'PIN_BLOCKED',
    PIN_TRY_LIMIT_EXCEEDED: 'PIN_TRY_LIMIT_EXCEEDED',
    CANNOT_CONTINUE_TRANSACTION: 'CANNOT_CONTINUE_TRANSACTION',
    PROMPT_FOR_AUTHORISATION_CODE: 'PROMPT_FOR_AUTHORISATION_CODE',
    OFFLINE_TXN_FAILED: 'OFFLINE_TXN_FAILED',
    CONTACTLESS_INITIALISATION_SUCCESS: 'CONTACTLESS_INITIALISATION_SUCCESS',
    PIN_ENTERED: 'PIN_ENTERED',
    CARD_SWIPED: 'CARD_SWIPED',
    CANCELLING_TRANSACTION: 'CANCELLING_TRANSACTION',
    CARD_PRESENTED: 'CARD_PRESENTED',
    SERVER_ERROR: 'SERVER_ERROR',
    OPTIONAL_DOWNLOAD_AVAILABLE: 'OPTIONAL_DOWNLOAD_AVAILABLE',
    CARD_NOT_RECOGNISED: 'CARD_NOT_RECOGNISED',
    CARD_SCHEME_DOES_NOT_ALLOW_TRANSACTION: 'CARD_SCHEME_DOES_NOT_ALLOW_TRANSACTION',
    CONNECTION_FAILED_DOWNLOAD: 'CONNECTION_FAILED_DOWNLOAD',
    SUBMITTING_OFFLINE_TXNS: 'SUBMITTING_OFFLINE_TXNS',
    OFFLINE_STORE_IS_FULL: 'OFFLINE_STORE_IS_FULL',
    BARCODE_INITIALISATION: 'BARCODE_INITIALISATION',
    BARCODE_RESULT: 'BARCODE_RESULT',
    BARCODE_CLOSED: 'BARCODE_CLOSED',
    BARCODE_SCAN_ITEM: 'BARCODE_SCAN_ITEM',
    AWAITING_KBD_CAPTURE: 'AWAITING_KBD_CAPTURE',
    AWAITING_NFC_SMART_CARD: 'AWAITING_NFC_SMART_CARD',
    CUSTOMER_RECEIPT_REQUIRED_QUERY: 'CUSTOMER_RECEIPT_REQUIRED_QUERY',
    CUSTOMER_RECEIPT: 'CUSTOMER_RECEIPT',
    DISCONNECT: 'DISCONNECT',
    PROCESSING_TRANSACTION: 'PROCESSING_TRANSACTION',
    CONTACT_TRANSACTION_REQUIRED: 'CONTACT_TRANSACTION_REQUIRED',
    AUTH_RESULT_ERROR: 'AUTH_RESULT_ERROR',
    FALLBACK_TO_SWIPE_DISABLED: 'FALLBACK_TO_SWIPE_DISABLED',
    INVALID_PED_CONFIGURATION: 'INVALID_PED_CONFIGURATION',
    GRATUITY_SELECTION_REQUIRED: 'GRATUITY_SELECTION_REQUIRED',
    ISSUE_NUMBER_REQUIRED: 'ISSUE_NUMBER_REQUIRED',
    CUSTOMER_PRESENT_NOT_PRESENT_SELECTION_REQUIRED: 'CUSTOMER_PRESENT_NOT_PRESENT_SELECTION_REQUIRED',
    CUSTOMER_NOT_PRESENT_OPTION_SELECTION_REQUIRED: 'CUSTOMER_NOT_PRESENT_OPTION_SELECTION_REQUIRED',
    ENTER_CHARGE_AUTH_CODE: 'ENTER_CHARGE_AUTH_CODE',
    CARD_BLOCKED: 'CARD_BLOCKED',
    INVALID_EXPIRY: 'INVALID_EXPIRY',
    GRATUITY_INVALID: 'GRATUITY_INVALID',
    INVALID_CARD: 'INVALID_CARD',
    REQUESTING_DCC: 'REQUESTING_DCC',
    DCC_CURRENCY_CHOICE: 'DCC_CURRENCY_CHOICE',
    CARDHOLDER_DCC_CURRENCY_CHOICE: 'CARDHOLDER_DCC_CURRENCY_CHOICE',
    START_BARCLAYS_BONUS_TRANSACTION: 'START_BARCLAYS_BONUS_TRANSACTION',
    UPDATE_BARCLAYS_BONUS_TRANSACTION: 'UPDATE_BARCLAYS_BONUS_TRANSACTION',
    CANCEL_BARCLAYS_BONUS_TRANSACTION: 'CANCEL_BARCLAYS_BONUS_TRANSACTION',
    CONFIRM_GRATUITY: 'CONFIRM_GRATUITY',
    BARCLAYS_BONUS_DISCOUNT_SUMMARY: 'BARCLAYS_BONUS_DISCOUNT_SUMMARY',
    BARCLAYS_BONUS_USE_BONUS: 'BARCLAYS_BONUS_USE_BONUS',
    BARCLAYS_BONUS_ENTER_REDEMPTION: 'BARCLAYS_BONUS_ENTER_REDEMPTION',
    BARCLAYS_BONUS_NOT_AVAILABLE: 'BARCLAYS_BONUS_NOT_AVAILABLE',
    REPRINT_COMPLETE: 'REPRINT_COMPLETE',
    PAYPOINT_ACCOUNT_EXTRACTION_FAILED: 'PAYPOINT_ACCOUNT_EXTRACTION_FAILED',
    PAYPOINT_AMOUNT_OUTSIDE_ALLOWED_RANGE: 'PAYPOINT_AMOUNT_OUTSIDE_ALLOWED_RANGE',
    PAYPOINT_CARD_EXPIRED: 'PAYPOINT_CARD_EXPIRED',
    PAYPOINT_INITIALISED: 'PAYPOINT_INITIALISED',
    PAYPOINT_INITIALISATION_FAILED: 'PAYPOINT_INITIALISATION_FAILED',
    PAYPOINT_INITIALISING: 'PAYPOINT_INITIALISING',
    PAYPOINT_INVALID_ACCOUNT: 'PAYPOINT_INVALID_ACCOUNT',
    PAYPOINT_INVALID_AMOUNT: 'PAYPOINT_INVALID_AMOUNT',
    PAYPOINT_INVALID_CAPTURE_METHOD: 'PAYPOINT_INVALID_CAPTURE_METHOD',
    PAYPOINT_INVALID_CARD_NUMBER: 'PAYPOINT_INVALID_CARD_NUMBER',
    PAYPOINT_INVALID_CONFIGURATION: 'PAYPOINT_INVALID_CONFIGURATION',
    PAYPOINT_INVALID_DENOMINATION: 'PAYPOINT_INVALID_DENOMINATION',
    PAYPOINT_INVALID_EXPIRY_DATE: 'PAYPOINT_INVALID_EXPIRY_DATE',
    PAYPOINT_INVALID_SCHEME: 'PAYPOINT_INVALID_SCHEME',
    PAYPOINT_INVALID_SCHEME_OPTION: 'PAYPOINT_INVALID_SCHEME_OPTION',
    PAYPOINT_INVALID_TOPUP_TYPE: 'PAYPOINT_INVALID_TOPUP_TYPE',
    PAYPOINT_INVALID_SERVICE_PROVIDER: 'PAYPOINT_INVALID_SERVICE_PROVIDER',
    PAYPOINT_INVALID_TRACK2_FORMAT: 'PAYPOINT_INVALID_TRACK2_FORMAT',
    PAYPOINT_INVALID_TRANSACTION_TYPE: 'PAYPOINT_INVALID_TRANSACTION_TYPE',
    PAYPOINT_KEYED_ENTRY_NOT_ALLOWED: 'PAYPOINT_KEYED_ENTRY_NOT_ALLOWED',
    PAYPOINT_MERCHANT_REFERENCE_REQUIRED: 'PAYPOINT_MERCHANT_REFERENCE_REQUIRED',
    PAYPOINT_NO_ACCOUNTS: 'PAYPOINT_NO_ACCOUNTS',
    PAYPOINT_PROCESSING_TRANSACTION: 'PAYPOINT_PROCESSING_TRANSACTION',
    PAYPOINT_RETRY_CONFIRMATION_DECISION: 'PAYPOINT_RETRY_CONFIRMATION_DECISION',
    PAYPOINT_SCHEME_NOT_RECOGNISED: 'PAYPOINT_SCHEME_NOT_RECOGNISED',
    PAYPOINT_TRANSACTION_CANCELLED: 'PAYPOINT_TRANSACTION_CANCELLED',
    PAYPOINT_TRANSACTION_TYPE_NOT_ALLOWED: 'PAYPOINT_TRANSACTION_TYPE_NOT_ALLOWED',
    PAYPOINT_SELECT_SCHEME_OPTION: 'PAYPOINT_SELECT_SCHEME_OPTION',
    PAYPOINT_DOWNLOAD_REQUIRED: 'PAYPOINT_DOWNLOAD_REQUIRED',
    PAYPOINT_SELECT_ACCOUNT: 'PAYPOINT_SELECT_ACCOUNT',
    PRINTING_PAYPOINT_RECEIPT: 'PRINTING_PAYPOINT_RECEIPT',
    LICENCE_DETAIL_CONFIRMATION: 'LICENCE_DETAIL_CONFIRMATION',
    LICENCE_FILE_REQUIRED: 'LICENCE_FILE_REQUIRED',
    PAY_POINT_SERVICE_UNAVAILABLE: 'PAY_POINT_SERVICE_UNAVAILABLE',
    PARK_RETAIL_GIFT_ACCOUNT_EXTRACTION_FAILED: 'PARK_RETAIL_GIFT_ACCOUNT_EXTRACTION_FAILED',
    PARK_RETAIL_GIFT_AMOUNT_OUTSIDE_ALLOWED_RANGE: 'PARK_RETAIL_GIFT_AMOUNT_OUTSIDE_ALLOWED_RANGE',
    PARK_RETAIL_GIFT_CARD_EXPIRED: 'PARK_RETAIL_GIFT_CARD_EXPIRED',
    PARK_RETAIL_GIFT_INITIALISATION_FAILED: 'PARK_RETAIL_GIFT_INITIALISATION_FAILED',
    PARK_RETAIL_GIFT_INITIALISING: 'PARK_RETAIL_GIFT_INITIALISING',
    PARK_RETAIL_GIFT_INVALID_ACCOUNT: 'PARK_RETAIL_GIFT_INVALID_ACCOUNT',
    PARK_RETAIL_GIFT_INVALID_AMOUNT: 'PARK_RETAIL_GIFT_INVALID_AMOUNT',
    PARK_RETAIL_GIFT_INVALID_CAPTURE_METHOD: 'PARK_RETAIL_GIFT_INVALID_CAPTURE_METHOD',
    PARK_RETAIL_GIFT_INVALID_CARD_NUMBER: 'PARK_RETAIL_GIFT_INVALID_CARD_NUMBER',
    PARK_RETAIL_GIFT_INVALID_CONFIGURATION: 'PARK_RETAIL_GIFT_INVALID_CONFIGURATION',
    PARK_RETAIL_GIFT_INVALID_EXPIRY_DATE: 'PARK_RETAIL_GIFT_INVALID_EXPIRY_DATE',
    PARK_RETAIL_GIFT_INVALID_TRACK2_FORMAT: 'PARK_RETAIL_GIFT_INVALID_TRACK2_FORMAT',
    PARK_RETAIL_GIFT_INVALID_TRANSACTION_TYPE: 'PARK_RETAIL_GIFT_INVALID_TRANSACTION_TYPE',
    PARK_RETAIL_GIFT_KEYED_ENTRY_NOT_ALLOWED: 'PARK_RETAIL_GIFT_KEYED_ENTRY_NOT_ALLOWED',
    PARK_RETAIL_GIFT_MERCHANT_REFERENCE_REQUIRED: 'PARK_RETAIL_GIFT_MERCHANT_REFERENCE_REQUIRED',
    PARK_RETAIL_GIFT_NO_ACCOUNTS: 'PARK_RETAIL_GIFT_NO_ACCOUNTS',
    PARK_RETAIL_GIFT_SERVICE_UNAVAILABLE: 'PARK_RETAIL_GIFT_SERVICE_UNAVAILABLE',
    PARK_RETAIL_GIFT_PROCESSING_TRANSACTION: 'PARK_RETAIL_GIFT_PROCESSING_TRANSACTION',
    PARK_RETAIL_GIFT_SCHEME_NOT_RECOGNISED: 'PARK_RETAIL_GIFT_SCHEME_NOT_RECOGNISED',
    PARK_RETAIL_GIFT_SELECT_ACCOUNT: 'PARK_RETAIL_GIFT_SELECT_ACCOUNT',
    PARK_RETAIL_GIFT_TRANSACTION_CANCELLED: 'PARK_RETAIL_GIFT_TRANSACTION_CANCELLED',
    PARK_RETAIL_GIFT_TRANSACTION_TYPE_NOT_ALLOWED: 'PARK_RETAIL_GIFT_TRANSACTION_TYPE_NOT_ALLOWED',
    PRINTING_PARK_RETAIL_GIFT_RECEIPT: 'PRINTING_PARK_RETAIL_GIFT_RECEIPT',
    PED_IN_ESD_RECOVERY_MODE: 'PED_IN_ESD_RECOVERY_MODE',
    UPDATE_BARCLAYCARD_FREEDOM_CONFIG: 'UPDATE_BARCLAYCARD_FREEDOM_CONFIG',
    PROCESSING_KEY_EXCHANGE: 'PROCESSING_KEY_EXCHANGE',
    BARCLAYS_GIFT_INITIALISING: 'BARCLAYS_GIFT_INITIALISING',
    GLOBAL_BLUE_TAX_FREE_SHOPPING_INITIALISING: 'GLOBAL_BLUE_TAX_FREE_SHOPPING_INITIALISING',
    GIVEX_INITIALISING: 'GIVEX_INITIALISING',
    M_VOUCHER_INITIALISING: 'M_VOUCHER_INITIALISING',
    PERFORMING_POST_CONFIRM_REVERSAL: 'PERFORMING_POST_CONFIRM_REVERSAL',
    MERCHANT_REFERENCE_LENGTH_INVALID: 'MERCHANT_REFERENCE_LENGTH_INVALID',
    INITIALISING: 'INITIALISING',
    ACCOUNT_EXTRACTION_FAILED: 'ACCOUNT_EXTRACTION_FAILED',
    AMOUNT_OUTSIDE_ALLOWED_RANGE: 'AMOUNT_OUTSIDE_ALLOWED_RANGE',
    TRANSAX_SV_INITIALISATION_FAILED: 'TRANSAX_SV_INITIALISATION_FAILED',
    TRANSAX_SV_INITIALISING: 'TRANSAX_SV_INITIALISING',
    NO_ACCOUNTS: 'NO_ACCOUNTS',
    TRANSAX_SV_SERVICE_UNAVAILABLE: 'TRANSAX_SV_SERVICE_UNAVAILABLE',
    INVALID_ISSUE_NUMBER: 'INVALID_ISSUE_NUMBER',
    CONFIRMATION_FAILED: 'CONFIRMATION_FAILED',
    PRINTING_RECEIPT: 'PRINTING_RECEIPT',
    WAITING_FOR_DONATION: 'WAITING_FOR_DONATION',
    FURTHER_PAYMENT_REQUIRED: 'FURTHER_PAYMENT_REQUIRED',
    SVS_INITIALISING: 'SVS_INITIALISING',
    SVS_INITIALISATION_FAILED: 'SVS_INITIALISATION_FAILED',
    SVS_INVALID_CONFIGURATION: 'SVS_INVALID_CONFIGURATION',
    SVS_SERVICE_UNAVAILABLE: 'SVS_SERVICE_UNAVAILABLE',
    PART_PAYMENT: 'PART_PAYMENT',
    OBTAIN_STAN: 'OBTAIN_STAN',
    INVALID_STAN: 'INVALID_STAN',
    IVR_REQUIRED: 'IVR_REQUIRED',
    ENTER_REFERENCE: 'ENTER_REFERENCE',
    PRINT_SHOP_COPY: 'PRINT_SHOP_COPY',
    MUST_INSERT_CARD: 'MUST_INSERT_CARD',
    PIN_BYPASSED: 'PIN_BYPASSED',
    ON_HOLD_TRANSACTION: 'ON_HOLD_TRANSACTION',
    REACTIVATION_REQUIRED: 'REACTIVATION_REQUIRED',
    CHOOSE_ACCOUNT: 'CHOOSE_ACCOUNT',
});

module.exports = VerifoneStatusNames;
